<div class="fill-background">
<div class="card fluid">
    <div class="card__content">
        <div class="width-full text-center">
             <div class="font-24 success-green bold mb-20 mt-10">
                <span class="icon-container">
                    <i class="fas fa-check"></i>
                </span>
                Contact Verification Complete 
             </div>
             <div class="mb-20">
                Your contact verification has been completed for the Ohio Department of Education.
             </div>
        </div>
    </div>
</div>
<div class="mt-20">
    <span class="basis-33">
        <span class="flex justify-center">
          <button title="Back To Application" id="" class="rounded-full hover-blue-800 black mobile" (click)="cservice.backToApplication()">
            <div class="btn-txt font-white bold">Take Me To My Application</div>
          </button>
        </span>
      </span>
</div>
</div>
